import { render, staticRenderFns } from "./Frequency.vue?vue&type=template&id=905cdeec&scoped=true&"
import script from "./Frequency.vue?vue&type=script&lang=js&"
export * from "./Frequency.vue?vue&type=script&lang=js&"
import style0 from "./Frequency.vue?vue&type=style&index=0&id=905cdeec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905cdeec",
  null
  
)

export default component.exports